import { SxProps, Theme } from '@mui/material';

/** Height the product group tree is capped at when the filter is open. */
export const productGroupTreeHeight = 240;

/**
 * Caps the product group tree and gives it its own scrollbar, so a deep hierarchy
 * cannot push the rest of the filter panel out of view.
 */
export const productGroupTreeScrollSx = (maxHeight: number): SxProps<Theme> => ({
  maxHeight,
  overflowY: 'auto',
  overflowX: 'hidden',
  // Keep the scrollbar from overlapping the node labels.
  pr: 0.5,
});
